// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTaxStatusForEntity_EntityFragment = { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string } | { __typename?: 'CLTTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'CRTTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'CustodialPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'DonorAdvisedFund', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'GPBusinessEntity', id: string } | { __typename?: 'GRATTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'ILITTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'IndividualPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'InsurancePersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'IrrevocableTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'JointPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'LLCBusinessEntity', id: string } | { __typename?: 'LPBusinessEntity', id: string } | { __typename?: 'PrivateFoundation', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'QPRTTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'RetirementPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'RevocableTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'SCorpBusinessEntity', id: string } | { __typename?: 'SLATTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } };

export type GetTaxStatusForEntityQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EntityWhereInput>;
}>;


export type GetTaxStatusForEntityQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & GetTaxStatusForEntity_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetTaxStatusForEntity: 'GetTaxStatusForEntity' as const
  },
  Fragment: {
    GetTaxStatusForEntity_Entity: 'GetTaxStatusForEntity_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetTaxStatusForEntity_EntityFragmentDoc = gql`
    fragment GetTaxStatusForEntity_Entity on Entity {
  id
  subtype {
    id
    ... on GRATTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on ILITTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on RevocableTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on SLATTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on IrrevocableTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on QPRTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on IndividualPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on JointPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on RetirementPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on CustodialPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on QualifiedTuitionPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on CRTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on CLTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on DonorAdvisedFund {
      id
      gstStatus
      inEstateStatus
    }
    ... on PrivateFoundation {
      id
      gstStatus
      inEstateStatus
    }
    ... on InsurancePersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
  }
}
    `;
export const GetTaxStatusForEntityDocument = gql`
    query GetTaxStatusForEntity($where: EntityWhereInput) {
  entities(where: $where) {
    edges {
      node {
        ...GetTaxStatusForEntity_Entity
      }
    }
  }
}
    ${GetTaxStatusForEntity_EntityFragmentDoc}`;

/**
 * __useGetTaxStatusForEntityQuery__
 *
 * To run a query within a React component, call `useGetTaxStatusForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxStatusForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxStatusForEntityQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTaxStatusForEntityQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxStatusForEntityQuery, GetTaxStatusForEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxStatusForEntityQuery, GetTaxStatusForEntityQueryVariables>(GetTaxStatusForEntityDocument, withFetchPolicyContext(options));
      }
export function useGetTaxStatusForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxStatusForEntityQuery, GetTaxStatusForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxStatusForEntityQuery, GetTaxStatusForEntityQueryVariables>(GetTaxStatusForEntityDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTaxStatusForEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaxStatusForEntityQuery, GetTaxStatusForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxStatusForEntityQuery, GetTaxStatusForEntityQueryVariables>(GetTaxStatusForEntityDocument, withFetchPolicyContext(options));
        }
export type GetTaxStatusForEntityQueryHookResult = ReturnType<typeof useGetTaxStatusForEntityQuery>;
export type GetTaxStatusForEntityLazyQueryHookResult = ReturnType<typeof useGetTaxStatusForEntityLazyQuery>;
export type GetTaxStatusForEntitySuspenseQueryHookResult = ReturnType<typeof useGetTaxStatusForEntitySuspenseQuery>;
export type GetTaxStatusForEntityQueryResult = Apollo.QueryResult<GetTaxStatusForEntityQuery, GetTaxStatusForEntityQueryVariables>;